export default __webpack_public_path__ + "static/media/sensotrend_dashboard_sharing_link.3009858d.png";